module.exports = __webpack_public_path__ + "static/media/code.d07dfde5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/code.jpg
// module id = 28
// module chunks = 0